import VisibleView from "components/hoc/VisibleView";
import { WidgetProps } from "types";
import { MetricChart } from "./charts";
import ChartActionDropdown from "../ChartActionDropdown";
import { ChartSource, ChartType } from "constant/chart";

const getComponent = (source: ChartSource, chart: ChartType) => {
    return MetricChart;
};

const EventWidget = ({
    gatewaysConfig,
    zoomLevel,
    panel,
    panel: { source, chart },
    dashboardId,
    onDelete,
    allRegistry,
}: WidgetProps) => {
    const Component = getComponent(source, chart);

    return (
        <>
            {Component && (
                <div className="position-relative h-100">
                    <ChartActionDropdown
                        panelId={panel.uuid}
                        dashboardId={dashboardId}
                        onDelete={onDelete}
                        panel={panel}
                    />
                    <VisibleView>
                        <Component
                            gatewaysConfig={gatewaysConfig}
                            zoomLevel={zoomLevel}
                            panel={panel}
                            dashboardId={dashboardId}
                            onDelete={onDelete}
                            allRegistry={allRegistry}
                        />
                    </VisibleView>
                </div>
            )}
        </>
    );
};

export default EventWidget;
